import Settings from "./CarrotConfig"

const SupportCenterBaseUri = Settings.ZENDESK_GUIDE
const DefaultLocale = "en-us"

enum SupportCenterLinks {
  HOW_DOES_CARROT_WORK_WITH_MY_INSURANCE = "articles/1260800886630-How-does-Carrot-work-with-my-health-insurance-deductible-",
  WHY_HAVE_DEDUCTIBLE_MANAGED_BY_CARROT = "articles/1260800847309",
  CARROT_CARD_SUPPORT_CENTER = "sections/360007236473-Carrot-Card"
}

const getSupportCenterLink = (link: SupportCenterLinks) => `${SupportCenterBaseUri}/${DefaultLocale}/${link}`

export { getSupportCenterLink, SupportCenterLinks }
